const ADMIN_EMPLOYEES = {
  SET_EMPLOYEES_QUERY: 'SET_ADMIN_EMPLOYEES_QUERY',
  SET_EMPLOYEE_QUERY: 'SET_ADMIN_EMPLOYEE_QUERY',
};

export default ADMIN_EMPLOYEES;
